import { reportError } from 'ha/helpers/bugsnag/reportError';
import { OneTrustCategoryIds } from '../types';

export const getActiveCategories = (): OneTrustCategoryIds[] => {
  const activeGroups = window?.OnetrustActiveGroups;

  if (typeof activeGroups !== 'string') {
    reportError('OnetrustActiveGroups is undefined or null');
    return [];
  }

  if (activeGroups.length === 0) {
    reportError('OnetrustActiveGroups is an empty string');
    return [];
  }

  return activeGroups.split(',').filter(Boolean) as OneTrustCategoryIds[];
};
